<template>
  <BaseModal
    :show="show"
    :title="$t('ReservationForm.assignEmployeeToRoom', { room: roomNumber })"
    @close="$emit('close')"
  >
    <div
      v-if="
        !pendingEmployee && companyInfo.allowListedEmployees && businessUnits
      "
    >
      <ContentList
        :title="'ReservationForm.findEmployee'"
        :collapsible="true"
        :open="openSection === 'search'"
        :smallText="true"
        class="mb-3"
        @toggle="(val) => (openSection = val ? 'search' : null)"
      >
        <EmployeeSelection
          :pre-selected-employees="''"
          :business-units="businessUnits"
          :selected-employees="alreadyAssignedEmployees"
          @selected-employee="handleEmployeeSelected"
        />
      </ContentList>
    </div>
    <p v-if="!pendingEmployee && companyInfo.allowListedEmployees" class="mt-3">
      {{ $t("ReservationForm.unknownEmployee") }}
    </p>
    <div v-if="!pendingEmployee && companyInfo.allowUnlistedEmployees">
      <ContentList
        :title="'ReservationForm.addEmployee'"
        :collapsible="true"
        :open="openSection === 'add'"
        :smallText="true"
        class="mt-3"
        @toggle="(val) => (openSection = val ? 'add' : null)"
      >
        <AddUnlistedEmployee
          @created-unlisted-employee="handleUnlistedEmployeeCreated"
        />
      </ContentList>
    </div>

    <!-- Pending selection summary -->
    <div v-if="pendingEmployee">
      <h5 class="title is-5 title--collapsible-title is-size-6">
        Geselecteerde gast
      </h5>
      <p
        class="mb-3 is-flex is-align-items-center is-justify-content-space-between"
      >
        <span>
          <strong
            >{{ pendingEmployee.firstName }}
            {{ pendingEmployee.lastName }}</strong
          >
          <template v-if="pendingEmployee.emailAddress">
            ({{ pendingEmployee.emailAddress }})
          </template>
        </span>
      </p>
      <AlertMessage class="mb-2" :message="overlapError" />
      <div class="is-flex is-justify-content-space-between">
        <button class="c-button c-button--small mt-4" @click="clearPending">
          <span class="icon is-small"><i class="fas fa-chevron-left"></i></span>
          <span>{{ $t("back") }}</span>
        </button>
        <button
          v-if="!overlapError"
          class="c-button c-button--secondary c-button--small mt-4"
          :disabled="isChecking"
          @click="confirmAdd"
        >
          <template v-if="!isChecking">
            <span class="icon is-small"><i class="fas fa-plus"></i></span>
            <span>{{ $t("add") }}</span>
          </template>
          <template v-else>
            <span class="is-flex is-align-items-center">
              <img
                class="mr-3"
                width="24"
                height="24"
                src="@/assets/images/loader.svg"
              />{{ $t("ReservationForm.checkingOverlap") }}</span
            >
          </template>
        </button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/shared/BaseModal.vue";
import ContentList from "@/components/hoteldetail/ContentList.vue";
import EmployeeSelection from "@/components/reservationform/EmployeeSelection.vue";
import AddUnlistedEmployee from "@/components/reservationform/AddUnlistedEmployee.vue";

export default {
  components: {
    BaseModal,
    ContentList,
    EmployeeSelection,
    AddUnlistedEmployee
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    roomNumber: {
      type: Number,
      required: true
    },
    businessUnits: {
      type: Array,
      default: () => []
    },
    companyInfo: {
      type: Object,
      required: true
    },
    alreadyAssignedEmployees: {
      type: Array,
      default: () => []
    },
    isChecking: {
      type: Boolean,
      default: false
    },
    overlapError: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      pendingEmployee: null,
      pendingUnlisted: false,
      pendingBusinessUnit: null,
      openSection: this.companyInfo?.allowListedEmployees
        ? "search"
        : this.companyInfo?.allowUnlistedEmployees
          ? "add"
          : null
    };
  },
  emits: [
    "close",
    "assign-employee",
    "assign-unlisted-employee",
    "confirm-assign",
    "clear-pending"
  ],
  watch: {
    show(newVal) {
      if (!newVal) {
        this.pendingEmployee = null;
        this.pendingUnlisted = false;
        this.pendingBusinessUnit = null;
      }
    }
  },
  methods: {
    handleEmployeeSelected(data) {
      this.pendingEmployee = data.employee;
      this.pendingUnlisted = false;
      this.pendingBusinessUnit = data.businessUnit;
      this.$emit("assign-employee", data);
    },
    handleUnlistedEmployeeCreated(data) {
      this.pendingEmployee = data.employee;
      this.pendingUnlisted = true;
      this.pendingBusinessUnit = null;
      this.$emit("assign-unlisted-employee", data);
    },
    confirmAdd() {
      if (!this.pendingEmployee) return;
      this.$emit("confirm-assign");
    },
    clearPending() {
      this.pendingEmployee = null;
      this.pendingUnlisted = false;
      this.pendingBusinessUnit = null;
      this.$emit("clear-pending");
    }
  }
};
</script>
